import React from 'react';

import { WarningMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';

import { useConfig } from '../../defaultConfig';
import type { PaymentType } from '../../generated-types';
import useTranslation from '../../hooks/useTranslation';

interface Props {
    paymentType: PaymentType;
    canReject: boolean;
    isFaked?: boolean;
}

const FuturePaymentWarningMessage: React.FC<Props> = ({ paymentType, canReject, isFaked = false }) => {
    const translated = useTranslation();
    const { recurringPaymentLink } = useConfig();
    if (paymentType === 'RECURRING_PAYMENT') {
        return (
            <WarningMessage
                icon={IconTypes.UTROPSTEGN_24}
                className="future-payment-details__warning-message"
                text={translated.futurePaymentDetails.recurringPayment.editWarning}
                clickableItem={
                    <Link href={recurringPaymentLink?.url}>
                        {translated.futurePaymentDetails.recurringPayment.editLink}
                    </Link>
                }
            />
        );
    }

    if (!canReject) {
        return (
            <WarningMessage
                className="future-payment-details__warning-message"
                text={
                    !isFaked
                        ? translated.futurePaymentDetails.noReject.editWarning
                        : translated.futurePaymentDetails.fakedLoanPayment.warning
                }
                icon={IconTypes.UTROPSTEGN_24}
            />
        );
    }

    return (
        <WarningMessage
            className="future-payment-details__warning-message"
            text={
                paymentType === 'FOREIGN_PAYMENT'
                    ? translated.futurePaymentDetails.foreignPayment.noEditWarning
                    : translated.futurePaymentDetails.normal.noEditWarning
            }
            icon={IconTypes.UTROPSTEGN_24}
        />
    );
};
export default FuturePaymentWarningMessage;
